import React from 'react';

import Button from '@/components/Button';

import { useStyles } from './styles';

interface StripeFormShellProps {
  children: React.ReactNode;
  showBackButton: boolean;
  onBack?: () => void;
  backButtonText: string;
  action: React.ReactNode;
}

// Layout for every state that isn't the mounted Stripe form: loading, retrying
// and failed. All three keep the caller's children and a Back button, because
// collapsing to a bare placeholder is what made WEBAPP-CCB a dead end — the
// children carry the price disclosure and, in the SMB modal, the heading the
// dialog's aria-labelledby points at, and Back is the only in-pane escape while
// a load is still outstanding.
export function StripeFormShell({
  children,
  showBackButton,
  onBack,
  backButtonText,
  action,
}: StripeFormShellProps): JSX.Element {
  const s = useStyles();

  return (
    <>
      <div className={s.formContent}>{children}</div>
      <div className={s.footer}>
        {showBackButton && onBack ? (
          <Button variant="text" onClick={onBack} classes={{ root: s.backButton }}>
            {backButtonText}
          </Button>
        ) : (
          <div />
        )}
        {action}
      </div>
    </>
  );
}

export default StripeFormShell;
